<script>
export default {
    
}
</script>

<template>
    <header id="header">
        <h1 class="heading">ヘッダー</h1>
        <nav class="head-nav">
            <ul class="head-list">
                <li class="head-list-item"><a href="#header" class="head-list-link">TOP</a></li>
                <li class="head-list-item"><a href="#uk" class="head-list-link">UK</a></li>
                <li class="head-list-item"><a href="#sy"  class="head-list-link">SY</a></li>
                <li class="head-list-item"><a href="#jo"  class="head-list-link">JO</a></li>
            </ul>
        </nav>
    </header>
</template>

<style scoped>
    ul{
        list-style: none;
    }
    a:link,a:visited,a:hover,a:active{
        color: white;
        text-decoration: none;
    }
    #header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        padding: 30px 10%;
        background-color: #3a4a5e;
    }
    .heading{
        color: white;
        font-size: 2.4rem;
        width:40%;
    }
    .head-nav{
        width: 60%;
    }
    .head-list{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 100%;
    }
    .head-list-item{
        width: 25%;
        font-size: 1.4rem;
        color: white;
    }
    .head-list-link{
            display: block;
            text-align: center;
            transition: all .5s;
    }
    .head-list-link:hover{
        background-color: rgba(255,255,255, .5)
    }
</style>

